// components
import { styled, Box, BoxProps } from '@mui/material';

export const StyledNpsClientBox = styled(Box)<BoxProps>(({ theme }) => ({
  '&& p': {
    color: theme.vars.palette.common.white
  }
}));
